"use client";

import { c as _c } from "react/compiler-runtime";
import { ArticleData, GlossaryTermData } from "@/sanity/interfaces";
import dynamic from "next/dynamic";
import { DateStringFormat } from "@/components/common/date-string/date-string";
import AuthorCard from "@/components/author/author-card/author-card";
import Image from "@/components/common/image/image";
import ResourceInfoCard from "./resource-info-card";
const DateString = dynamic(() => import("@/components/common/date-string/date-string"), {
  ssr: false
});
interface IResourceInfoProps {
  data: ArticleData | GlossaryTermData;
  className?: string;
}
const ResourceInfo = props => {
  const $ = _c(34);
  const {
    data,
    className: t0
  } = props;
  const className = t0 === undefined ? "" : t0;
  const {
    author,
    reviewer,
    estimatedReadMins,
    modifiedAt,
    _updatedAt,
    publishedAt,
    _createdAt
  } = data;
  const dateToDisplay = modifiedAt ?? _updatedAt ?? publishedAt ?? _createdAt;
  let t1;
  if ($[0] !== author || $[1] !== reviewer) {
    t1 = (author || reviewer) && <><div className="flex flex-col gap-3 md:hidden">{author && <AuthorCard id={author.name ?? ""} label="Written By" name={author.name ?? ""} role={author?.role} image={author.photo?.asset} />}{reviewer && <AuthorCard id={reviewer.reviewedBy?.name ?? ""} label="Reviewed By" name={reviewer.reviewedBy?.name ?? ""} role={reviewer.reviewedBy?.role} image={reviewer.reviewedBy?.photo?.asset} isLink={false} className="border-y-[1px] border-[#E5E7EB] py-3" />}</div><div className="hidden w-full grid-cols-2 border-b-[1px] border-[#E5E7EB] pb-5 md:grid">{author && <AuthorCard id={author.name ?? ""} label="Written By" name={author.name ?? ""} role={author?.role} image={author.photo?.asset} />}{reviewer && <AuthorCard id={reviewer.reviewedBy?.name ?? ""} label="Reviewed By" name={reviewer.reviewedBy?.name ?? ""} role={reviewer.reviewedBy?.role} image={reviewer.reviewedBy?.photo?.asset} isLink={false} className="-ml-7 border-l-[1px] border-[#E5E7EB] pl-7" />}</div></>;
    $[0] = author;
    $[1] = reviewer;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== dateToDisplay) {
    t2 = dateToDisplay && <ResourceInfoCard title="Last Updated"><DateString date={dateToDisplay} format={DateStringFormat.COMMA} /></ResourceInfoCard>;
    $[3] = dateToDisplay;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== estimatedReadMins || $[6] !== reviewer) {
    t3 = estimatedReadMins && <><ResourceInfoCard title="Est. Time" className="-ml-4 border-l-[1px] border-[#E5E7EB] pl-4">{estimatedReadMins} min{estimatedReadMins > 1 ? "s" : ""}</ResourceInfoCard>{reviewer && <div className="-ml-4 border-l-[1px] border-[#E5E7EB] pl-4"><div className="flex h-[40px] flex-row items-center justify-center gap-1 rounded-3xl bg-[#00949014] p-3"><Image src="/fact-checked.svg" alt="Fact Checked" width={22} height={22} className="size-3 md:size-5" /><span className="text-xs font-bold leading-none text-[#00736e]">FACT-CHECKED</span></div></div>}</>;
    $[5] = estimatedReadMins;
    $[6] = reviewer;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex w-full items-center justify-between gap-4 md:grid md:grid-cols-3 md:gap-6">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t4) {
    t5 = <div className="flex w-full flex-col gap-3 border-b-[1px] border-[#E5E7EB] pb-3 md:gap-5 md:pb-5 lg:hidden">{t1}{t4}</div>;
    $[11] = t1;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== author) {
    t6 = author && <AuthorCard id={author.name ?? ""} label="Written By" name={author.name ?? ""} role={author?.role} image={author.photo?.asset} />;
    $[14] = author;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== reviewer) {
    t7 = reviewer && <><div className="h-full max-h-[80%] w-[1px] bg-[#E5E7EB]" /><AuthorCard id={reviewer.reviewedBy?.name ?? ""} label="Reviewed By" name={reviewer.reviewedBy?.name ?? ""} role={reviewer.reviewedBy?.role} image={reviewer.reviewedBy?.photo?.asset} isLink={false} /></>;
    $[16] = reviewer;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== dateToDisplay) {
    t8 = dateToDisplay && <><div className="h-full max-h-[80%] w-[1px] bg-[#E5E7EB]" /><ResourceInfoCard title="Last Updated"><DateString date={dateToDisplay} format={DateStringFormat.COMMA} /></ResourceInfoCard></>;
    $[18] = dateToDisplay;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== estimatedReadMins) {
    t9 = estimatedReadMins && <><div className="h-full max-h-[80%] w-[1px] bg-[#E5E7EB]" /><ResourceInfoCard title="Est. Time">{estimatedReadMins} minute{estimatedReadMins > 1 ? "s" : ""}</ResourceInfoCard></>;
    $[20] = estimatedReadMins;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== reviewer) {
    t10 = reviewer && <><div className="h-full max-h-[80%] w-[1px] bg-[#E5E7EB]" /><div className="flex h-[40px] flex-row items-center justify-center gap-3 rounded-3xl bg-[#00949014] px-8 py-2"><Image src="/fact-checked.svg" alt="" width={22} height={22} className="size-5" /><span className="text-sm font-bold leading-none text-[#00736e]">FACT-CHECKED</span></div></>;
    $[22] = reviewer;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    t11 = <div className="hidden h-20 w-full items-center justify-between gap-2 border-b-[1px] border-[#E5E7EB] pb-3 lg:flex">{t6}{t7}{t8}{t9}{t10}</div>;
    $[24] = t10;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== className || $[31] !== t11 || $[32] !== t5) {
    t12 = <div className={className}>{t5}{t11}</div>;
    $[30] = className;
    $[31] = t11;
    $[32] = t5;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
};
export default ResourceInfo;